export const CONSTSTRINGS = {
  PAYMENT_METHOD: 'Payment Method',
  CARD_INFORMATION: 'Card Information',
  TOT_CERTIFICATE: 'TOT Certificate',
  EMAIL: 'Email Address for Payment Confirmation',
};

export const CC_PAYMENT = 0;

export const ACH_PAYMENT = 1;

export const CREDIT_CARD_TAB = CC_PAYMENT;

export const ACH_PAYMENT_TAB = ACH_PAYMENT;

export const PAYMENT_METHOD_LABELS = {
  cc: 'Card Processor Fee',
  ach: 'Bank Processor Fee' // TODO: Ask Bing and/or Eileen about what to put here
};

export const PRORATED_PERMIT_FEE_LABEL = 'Permit Fee';

export const TOTAL_PAYMENT_LABEL = 'Total';
